export const getEnvironmentMode = ():
  | "energie"
  | "property"
  | "food-wld"
  | "hcare-wld"
  | "auto-wld" => {
  const env = import.meta.env.VITE_APP_ENV;

  switch (env) {
    case "development-energy-fr":
    case "production-energy-es":
    case "production-energy-fr":
    case "staging-energy-fr":
    case "production-energy-middle-east":
      return "energie";

    case "development-property-ae":
    case "production-property-ae":
      return "property";

    case "production-food-wld":
    case "development-food-wld":
      return "food-wld";

    case "development-hcare-wld":
      return "hcare-wld";

    case "development-auto-wld":
      return "auto-wld";

    default:
      return "energie";
  }
};
